import React from 'react';

import { useStoreContext } from 'features/store';

import { RemoveUnavailableItemsModal } from 'components/remove-unavailable-items-modal';
import { t } from 'state/intl/translations';

// NOTE:  Dialogs should be children of the Actionsheet component for proper visual display.
export const DialogsContainer = () => {
  const {
    StoreChangeDialog,
    onConfirmStoreChange,
    onConfirmStoreChangeParams,
    clearOnConfirmStoreChangeParams,
  } = useStoreContext();

  const handleOnConfirmCb = () => {
    onConfirmStoreChange(onConfirmStoreChangeParams);
    clearOnConfirmStoreChangeParams();
  };

  return (
    <>
      {onConfirmStoreChangeParams?.unavailableCartEntries && (
        <RemoveUnavailableItemsModal
          onConfirmCb={handleOnConfirmCb}
          unavailableCartEntries={onConfirmStoreChangeParams?.unavailableCartEntries}
          unavailableChildrenCartEntries={
            onConfirmStoreChangeParams?.unavailableChildrenCartEntries
          }
        />
      )}
      <StoreChangeDialog heading={t('changeStores')} />
    </>
  );
};
